import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IntroductionComponent } from './introduction/introduction.component';
import { FirmInformationComponent } from './firm-information/firm-information.component';
import { InvestmentStrategyMainComponent } from './investment-strategy-main/investment-strategy-main.component';
import { OpenEndFundsComponent } from './open-end-funds/open-end-funds.component';
import { ClosedEndFundsComponent } from './closed-end-funds/closed-end-funds.component';
import { OtherFundsComponent } from './other-funds/other-funds.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { ClosedEndFunds } from './Utils/formdata.models';

const routes: Routes = [
  {
    path: 'introduction',
    component: IntroductionComponent
  },
  {
    path: 'firm-information',
    component: FirmInformationComponent
  },
  {
    path: 'investment-strategy-main',
    component: InvestmentStrategyMainComponent
  },
  {
    path: 'open-end-funds',
    component: OpenEndFundsComponent
  },
  {
    path: 'closed-end-funds',
    component: ClosedEndFundsComponent
  },
  {
    path: 'other-funds',
    component: OtherFundsComponent
  },
  {
    path: 'thank-you',
    component: ThankYouComponent
  },
  { path: '', redirectTo: 'introduction', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
